import React, { useState, useEffect } from 'react';
import { useQuery } from '../../hooks';

import styles from './ConfirmationPage.module.css';

const ConfirmationPage = () => {
  let query = useQuery();
  const [errors, setErrors] = useState({ message: '' });
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    const token = query.get('token');
    handleSubmit(token);
  }, []);

  return (
    <div className={styles.app}>
      <div>
        <form className={styles.form} onSubmit={handleSubmit} noValidate>
          <div className={styles.appHeader}>
            <img src="/images/logo.svg" className={styles.appLogo} alt="logo" />
          </div>

          {!isSubmitted ? (
            <>
              {errors.message ? (
                <div className={styles.erroBox}>
                  <p>{errors.message}</p>
                </div>
              ) : (
                <h1> Loading... </h1>
              )}
            </>
          ) : (
            <div className={styles.successBox}>
              <p>Account was verified successfully 😉 </p>
            </div>
          )}
        </form>
      </div>
    </div>
  );

  async function handleSubmit(token) {
    setErrors({ message: '' });

    if (!token) {
      return setErrors({ message: 'Invalid token!' });
    }

    try {
      const BASE_URL = `${process.env.REACT_APP_BASE_URL}/auth-confirm-account`;

      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ token: token }),
      };

      // return;
      const request = await fetch(BASE_URL, options);
      const resp = await request.json();

      if (resp.status === 200) {
        setIsSubmitted(true);
      } else {
        setErrors({ message: resp.message });
      }
    } catch (err) {
      setErrors({ message: err.message });
    }
  }
};

export default ConfirmationPage;
